<template>
  <div class="columns">
    <div class="column is-offset-2 is-8">
      <p>
        ETF information provided by <a href="https://iextrading.com/developer/docs/">IEX's API</a>.
      </p>
      <p>
        Acorns portfolio information (ETF/percentage split) taken from Acorns app
      </p>
      <p>
        Built using Vuejs and Bulma css.
      </p>
      <p>
        <a href="https://github.com/andyklimczak/portfolio-calculator">Code on GitHub</a>
      </p>
      <p>
        If you would like to join Acorns, here is my <a href="https://acorns.com/invite/74Q9PR">referral link</a>.
        But definitely do not feel obligated to use it.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'About'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/About.vue